import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[ngVar]',
})
export class VarDirective {
  context: any = {};
  @Input()
  set ngVar(context: any) {
    this.context.ngVar = context;
  }

  constructor(
    private vcRef: ViewContainerRef,
    private templateRef: TemplateRef<any>
  ) {
    this.vcRef.createEmbeddedView(this.templateRef, this.context);
  }
}
